if (ID['filters']) {


    document.addEventListener("DOMContentLoaded", () => {
        FNC.filters.filters();
        FNC.filters.priceSlider();

        App.resize(() => {
            if (App.smDown()) {
                document.getElementById('filterModal').classList.remove('modal-shown-static')

            } else {
                document.getElementById('filterModal').classList.add('modal-shown-static')
                $('#filterModal').modal('hide')

            }

        })()

        FNC.filters.intFilterColors();

    });

    document.addEventListener('keyup', (e) => {
        if (e.target && e.target.classList.contains('filter-search')) {
            const
                value = e.target.value.toLowerCase(),
                el = e.target.dataset.filterSearch;

            Array.prototype.filter.call(document.querySelectorAll('#' + el + '-list .custom-control'), e => {

                Array.prototype.filter.call(e.querySelectorAll('label .title'), label => {
                    e.hidden = label.innerHTML.trim().indexOf(value) === -1;

                })

            });

        }

    })

}


FNC.filters.filters = () => {
    [...document.getElementsByClassName('click-filter')].forEach(el => {
        el.addEventListener('click', () => {
            naja.uiHandler.submitForm(ID['frm-filters-filtersForm'])

        })

    });

};

FNC.filters.priceSlider = () => {

    const slider = document.getElementById('price-slider');
    if (!_.isNull(slider)) {
        const
            range = JSON.parse(slider.dataset.sliderValues),
            intl = JSON.parse(slider.dataset.sliderIntl),
            rangeRet = {};

        _.set(rangeRet, 'min', range.min);
        for (let [key, val] of Object.entries(range)) {
            if(!_.includes(['min', 'max'], key)) {

                let objectKey = _.round((val / range.max) * 100);

                if (objectKey !== 100) {
                    objectKey = objectKey + 1;

                }

                _.set(rangeRet,  objectKey + '%', val);

            }

        }
        _.set(rangeRet, 'max', range.max);

        if (_.isUndefined(slider.noUiSlider)) {
            // price slider
            noUiSlider.create(slider, {
                start: [slider.dataset.minRange, slider.dataset.maxRange],
                snap: true,
                connect: true,
                range: rangeRet
            });

            const priceSliderValues = [
                ID['price-slider-min'],
                ID['price-slider-max']
            ]


            slider.noUiSlider.on('update', (values, handle) => {
                priceSliderValues[handle].value = parseFloat(values[handle]);/*FN.priceFormat(parseFloat(values[handle]), intl)*/;
                if (handle) {
                    ID['price-max-value'].value = FN.priceFormat(parseFloat(values[handle]), intl);

                } else {
                    ID['price-min-value'].value = FN.priceFormat(parseFloat(values[handle]), intl);

                }

            });

            slider.noUiSlider.on('end', (values) => {
                let frm = ID['frm-filters-filtersForm'];
                ID['price-slider-min'].value = values[0];
                ID['price-slider-max'].value = values[1];
                naja.uiHandler.submitForm(ID['frm-filters-filtersForm']);

            })

        }

    }

};

FNC.filters.intFilterColors = () => {
    const colorFilters = document.getElementsByClassName('color-filter');
    for (let [key, element] of Object.entries(colorFilters)) {
        element.style.background = element.dataset.color;

    }

}

naja.addEventListener('success', () => {
    FNC.filters.filters();
    FNC.filters.priceSlider();
    FNC.filters.intFilterColors();

    $('[data-toggle="tooltip"]').tooltip('dispose').tooltip('enable');

})





